import { Address } from "viem";
import { contractAddresses } from "../../meta";

export const PRICE_DECIMALS = 8;

export const HARDCODED_USC_PRICE: number | undefined = 1;

export const getHardcodedTokenPrice = (
  address?: Address
): number | undefined => {
  if (!address || HARDCODED_USC_PRICE === undefined) return undefined;

  return address.toLowerCase() === contractAddresses.USC.toLowerCase()
    ? HARDCODED_USC_PRICE
    : undefined;
};
